import Class from './c-pagination';
import './c-pagination@';

export default Class;